module.exports = __webpack_public_path__ + "static/media/open_url_summary.48d2b043.svg";